import React from 'react';

export const useOpenState = (): [boolean, () => void, () => void] => {
  const [open, setOpen] = React.useState<boolean>(false);

  const onOpen = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return [open, onOpen, onClose];
};
